export default __webpack_public_path__ + "static/media/Asset 5_11zon.19008280.webp";